import { GraphQLClient } from 'graphql-request'
import { getCookie } from '@/utils'
import Queries from './graphql/queries'
import Mutations from './graphql/mutations'

class API {
  constructor() {
    let params = new URLSearchParams(location.search)
    this.project = getCookie('kvass.project') || params.get('project-id')
    this.projectType = getCookie('kvass.projectType') || 'default'
  }

  get logo() {
    return `https://assets.kvass.no/65549f5524112600ce28c213`
  }

  get logoInverted() {
    return `https://assets.kvass.no/65549f5524112600ce28c213`
  }

  get favicon() {
    return `/api/project/${this.project}/favicon`
  }

  get projectId() {
    return this.project
  }

  request(...args) {
    return new GraphQLClient('/api/graphql', {
      headers: {
        'accept-language': document.querySelector('html').getAttribute('lang'),
      },
    }).request(...args)
  }

  getProject(id) {
    if (!id) id = this.project

    let getQuery = () => {
      return Queries.Project
    }

    return this.request(getQuery(), { id }).then(data => data.Project)
  }

  getRoot(id) {
    if (!id) id = this.project
    return this.request(Queries.Root, { id }).then(data => data.Project)
  }

  getResidential(id) {
    return this.request(Queries.Residential, { id }).then(data => data.Residential)
  }

  createLead(data) {
    return this.request(Mutations.LeadCreate, { data }).then(data => data.LeadCreate)
  }
}

export default new API()
